
export const Environment = {    /**
     * Url base de consulta dos dados dessa aplicação */
    URL_BASE: process.env.REACT_APP_BASE,

    URL_API: process.env.REACT_APP_API,

    DOMAIN: process.env.REACT_APP_DOMAIN,

    USER_PICTURE_DEFAULT: process.env.REACT_APP_USER_PICTURE_DEFAULT,

    DATA_IBGE: 'https://servicodados.ibge.gov.br/api/v1/localidades/estados',

    INPUT_DE_BUSCA: 'Pesquisar na Cremolatto',

    LISTAGEM_VAZIA: 'Nenhum registro encontrado.',

    LIMITE_DE_LINHAS: 100,

    NO_PEDIDOS: "Aqui você encontra-ra seus pedidos realizados ou em andamento, no momento ainda não encontramos nenhum pedido,]mas temos a certeza que logo terá  muitos pedidos aqui boas compras",

    BUSINESS_NAME: process.env.REACT_APP_BUSINESS_NAME,

    NO_IMAGE: process.env.REACT_APP_NO_IMAGE,  
    
    WHATSAPP_NUMBER: process.env.REACT_APP_WHATSAPP_NUMBER,

    DST_EMAIL: process.env.REACT_APP_DST_EMAIL,

    LANDING_PAGE_TOKEN: process.env.REACT_APP_LANDING_PAGE_TOKEN,

}

/**
 * Substitui URLs de produção pela URL local quando em ambiente de desenvolvimento
 * @param url - URL completa ou relativa vinda do banco de dados
 * @returns URL ajustada para o ambiente local ou absoluto para produção
 */
export const replaceUrlForLocal = (url: string): string => {
    if (!url) return '';
    
    // Limpa a string caso ela venha como "undefinedfilename.jpg" (erro comum de concatenação no back)
    let cleanedUrl = url.toString();
    if (cleanedUrl.startsWith('undefined')) {
        cleanedUrl = cleanedUrl.replace('undefined', '');
    }

    // URL de produção padrão
    const productionUrl = 'https://api.newzape.com.br';
    
    // Usa somente a URL de API definida no .env ou a URL de produção padrão
    const apiBase = Environment.URL_API || productionUrl;

    let finalUrl = cleanedUrl;

    // Se a URL já for absoluta (começar com http)
    if (cleanedUrl.startsWith('http')) {
        if (cleanedUrl.includes(productionUrl)) {
            finalUrl = cleanedUrl.replace(productionUrl, apiBase);
        }
    } else {
        // Se for um caminho relativo ou apenas o nome do arquivo
        // Se não começar com /files/, adicionamos para garantir que a rota de estáticos da API seja usada
        const path = cleanedUrl.startsWith('/files') ? cleanedUrl : (cleanedUrl.startsWith('/') ? `/files${cleanedUrl}` : `/files/${cleanedUrl}`);
        finalUrl = `${apiBase}${path}`;
    }

    // Remove barras duplas duplicadas (ex: http://base//files/ -> http://base/files/)
    // Mas preserva as barras após o protocolo (http://)
    return finalUrl.replace(/([^:]\/)\/+/g, "$1");
}



